<template>
    <div class="animated fadeIn wrap">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <form @submit="ValidarForm">
                        <header class="card-header">
                            <div class="d-flex">
                                <strong class="align-self-center">{{
                                    $t("sectionRelatorio.relatorioFiltroTitle")
                                }}</strong>
                            </div>
                        </header>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                    <div class="form-group">
                                        <label for>{{
                                            $t("sectionPesquisaSatisfacao.dataAberturaAtendimento")
                                        }}</label>
                                        <input v-model="filtro.dataAberturaAtendimento" type="date" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                    <div class="form-group">
                                        <label for>{{
                                            $t("sectionPesquisaSatisfacao.dataFechamentoAtendimento")
                                        }}</label>
                                        <input v-model="filtro.dataFechamentoAtendimento" type="date"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4" title="Selecione um ou mais usuários">
                                    <div class="form-group">
                                        <label for>{{
                                            $t("sectionRelatorio.relatorioUsuario")
                                        }}</label>
                                        <v-select v-model="filtro.usuarios" :placeholder="$t('textSelecione')"
                                            :options="usuarioOptions" multiple>
                                            <template slot="no-options">
                                                {{ $t("textNenhumResultado") }}
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                    <div class="form-group">
                                        <label for>{{
                                            $t("sectionPesquisaSatisfacao.dataInicialAvaliacao")
                                        }}</label>
                                        <input v-model="filtro.dataInicialAvaliacao" type="date" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                    <div class="form-group">
                                        <label for>{{
                                            $t("sectionPesquisaSatisfacao.dataFinalAvaliacao")
                                        }}</label>
                                        <input v-model="filtro.dataFinalAvaliacao" type="date" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-5 col-xl-3">
                                    <div class="form-group">
                                        <label for>{{ $t("sectionConversas.conversasEtapas") }}</label>
                                        <v-select v-model="filtro.etapas" class="style-chooser"
                                            :placeholder="$t('textSelecione')" :options="etapaOptions" multiple>
                                            <template slot="no-options">
                                                {{ $t("textAguardeNenhumResultado") }}
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                    <div class="form-group">
                                        <label for>{{
                                            $t("sectionRelatorio.relatorioTipo")
                                        }}</label>
                                        <select v-model="filtro.tipo" class="form-control">
                                            <option selected value>{{ $t("textSelecione") }}</option>
                                            <option value="1">WhatsApp</option>
                                            <option value="2">Facebook</option>
                                            <option value="3">E-mail</option>
                                            <option value="4">Instagram</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-print">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button class="btn btn-primary mr-2" type="submit">
                                            {{ $t("btFiltrar") }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div v-if="loading" class="loading-container">
                        <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
                    </div>
                    <div v-else>
                        <header class="card-header">
                            <div class="d-flex">
                                <strong class="align-self-center">{{
                                    $t("sectionPesquisaSatisfacao.resultados")
                                }}</strong>
                                <h3 class="ml-auto" v-if="resultados.length > 0">
                                    <a href="#" class="no-print" @click="DownloadCsv" :disabled="loadingItens">Download CSV</a>
                                </h3>
                            </div>
                        </header>
                        <div class="card-body">
                            <span v-if="resultados.length === 0">{{$t('sectionPesquisaSatisfacao.nenhumaPergunta')}}</span>
                            <b-card no-body class="mb-2" v-for="(resultado, index) in resultados" :key="resultado.id">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <div class="d-flex">
                                        <div class="col-7">
                                            <strong class="align-self-center">
                                                {{ index + 1 }} - {{ resultado.descricaoPergunta }}
                                            </strong>
                                        </div>
                                        <div class="col text-center">
                                            <strong>
                                                <div>
                                                    {{ resultado.quantidadeRespostas }}
                                                </div>
                                                {{ $t("sectionPesquisaSatisfacao.resposta") }}
                                            </strong>
                                        </div>
                                        <div class="col text-center">
                                            <strong>
                                                {{ ObterTipoResposta(resultado.tipoResposta) }}
                                            </strong>
                                        </div>
                                        <div class="col text-center">
                                            <strong>
                                                {{ resultado.media }}
                                                <div>
                                                    <span v-if="resultado.tipoResposta === 1">
                                                        {{ $t("sectionPesquisaSatisfacao.comentarios") }}
                                                    </span>
                                                    <span
                                                        v-if="resultado.tipoResposta === 2 || resultado.tipoResposta === 3">
                                                        {{ $t("sectionPesquisaSatisfacao.media") }}
                                                    </span>
                                                    <span v-if="resultado.tipoResposta === 4">
                                                        {{ $t("sectionPesquisaSatisfacao.simNaoRel") }}
                                                    </span>
                                                </div>
                                            </strong>
                                        </div>
                                        <div class="ml-auto">
                                            <b-button block v-b-toggle="'accordion-' + index" variant="info"><i
                                                    class="fas fa-chevron-down"></i></b-button>
                                        </div>
                                    </div>
                                </b-card-header>
                                <b-collapse :id="'accordion-' + index" role="tabpanel">
                                    <b-card-body>
                                        <b-table :items="resultado.respostas" :fields="fields" show-empty 
                                            :empty-text="$t('sectionPesquisaSatisfacao.nenhumaPergunta')">
                                            <template #cell(dataAvaliacao)="data">
                                                {{new Date(data.item.dataAvaliacao).toLocaleString()}}
                                            </template>
                                            <template #cell(dataAberturaAtendimento)="data">
                                                {{new Date(data.item.dataAberturaAtendimento).toLocaleString()}}
                                            </template>
                                            <template #cell(dataEncerramentoAtendimento)="data">
                                                {{new Date(data.item.dataEncerramentoAtendimento).toLocaleString()}}
                                            </template>
                                            <template #cell(origem)="data" >
                                                <strong >
                                                    {{ObterTipoNome(data.item.origem)}}
                                                </strong>
                                            </template>
                                            <template #cell(resposta)="data">
                                                <span v-if="resultado.tipoResposta === 2" class="badge badge-warning" style="color: yellow;">
                                                    {{RetornarEstrela(data.item.resposta)}}
                                                </span>
                                                <span v-if="resultado.tipoResposta === 4" :class="RetornaBadge(data.item.resposta)">
                                                    {{RetornarSimNao(data.item.resposta)}}
                                                    </span>

                                                <span v-if="resultado.tipoResposta === 1 || resultado.tipoResposta === 3" >
                                                     {{ data.item.resposta }}
                                                </span>
                                                
                                            </template>
                                            <template #cell(tag)="data">
                                                <span v-for="tag in data.item.tag"
                                                class="tags-margin tag-badge"
                                                :style="'background-color: ' + tag.cor">
                                                    {{tag.descricao }}
                                                
                                                </span>
                                            </template>
                                        </b-table>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import RotateSquare from "../../components/RotateSquare";
import TipoAtendimento from "../../enums/TipoAtendimento";

export default {
    name: "RelatorioPesquisaSatisfacao",
    components: { RotateSquare },
    data() {
        return {
            locale: this.$i18n.locale,
            filtro: {
                contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
                dataAberturaAtendimento: "",
                dataFechamentoAtendimento: "",
                dataInicialAvaliacao: "",
                dataFinalAvaliacao: "",
                usuarios: [],
                etapas: [],
                tipo: ""
            },
            usuarioOptions: [],
            etapaOptions: [],
            loading: false,
            resultados: [],
            fields: [
                { key: 'dataAvaliacao', label: this.$t('sectionPesquisaSatisfacao.dataAvaliacao') },
                { key: 'dataAberturaAtendimento', label: this.$t('sectionPesquisaSatisfacao.dataAbertura') },
                { key: 'dataEncerramentoAtendimento', label: this.$t('sectionPesquisaSatisfacao.dataFechamento')},
                { key: 'atendente', label: this.$t('sectionConversas.conversasAtendente')},
                { key: "tag", label: this.$t("sectionConversas.conversasEtapas")},
                { key: "origem", label: this.$t("sectionOrcamento.orcamentoOrigem")},
                { key: "cliente", label: this.$t("sectionPesquisaSatisfacao.cliente")},
                { key: "resposta", label: this.$t("sectionPesquisaSatisfacao.respostaTable"), sortable:true}
            ]
        };
    },
    computed: {
    },
    watch: {
        locale(val) {
            this.$i18n.locale = val;
        }
    },
    mounted() {
        this.ObterUsuarioSelect2();
        this.ObterEtapaSelect2();
    },
    created() { },
    methods: {
        ValidarForm(evt) {
            evt.preventDefault();
            console.log("Filtro ", this.filtro)
            this.ObterGrid();
        },
        ObterEtapaSelect2() {
            if (this.etapaOptions.length > 0) return

            this.$http({
                url: "/etapa/obter-select2",
                method: "GET"
            })
                .then((response) => {
                    this.etapaOptions = response.data
                })
                .catch((erro) => {
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    })
                })
        },
        ObterUsuarioSelect2() {
            this.loading = true;
            this.$http({
                url:
                    "/usuario/obter-select2/" +
                    this.$store.getters.getAutenticacao.contaSelecionadaId,
                method: "GET"
            })
                .then((response) => {
                    this.loading = false;
                    this.usuarioOptions = response.data;
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        ObterTipoNome(tipo) {
            switch (tipo) {
                case TipoAtendimento.WhatsApp:
                    return "WhatsApp";
                case TipoAtendimento.Facebook:
                    return "Facebook";
                case TipoAtendimento.Email:
                    return "E-mail";
                case TipoAtendimento.Instagram:
                    return "Instagram";
                default:
                    return "";
            }
        },
        ObterCorOrigem(tipo) {
            switch (tipo) {
                case TipoAtendimento.WhatsApp:
                    return "green";
                case TipoAtendimento.Facebook:
                    return "Facebook";
                case TipoAtendimento.Email:
                    return "E-mail";
                case TipoAtendimento.Instagram:
                    return "Instagram";
                default:
                    return "";
            }
        },
        RetornarEstrela(estrela)
        {
            switch (estrela) {
                case "1":
                    return "★";
                case "2":
                    return "★★";
                case "3":
                    return "★★★";
                case "4":
                    return "★★★★";
                case "5":
                    return "★★★★★";
                default:
                    return this.$t('sectionPesquisaSatisfacao.comentario');
            }
        },
        RetornarSimNao(resp){
            switch (resp) {
                case "true":
                    return this.$t('textYes');
                case "false":
                    return this.$t('textNo');
                default:
                    return this.$t('textYes');
            }
        },
        RetornaBadge(resp){
            switch (resp) {
                case "true":
                    return "badge badge-success";
                case "false":
                    return "badge badge-danger"
                default:
                    return "badge badge-secondary"
            }
        },
        ObterTipoResposta(tipo) {
            switch (tipo) {
                case 1:
                    return this.$t('sectionPesquisaSatisfacao.comentario');
                case 2:
                    return this.$t('sectionPesquisaSatisfacao.estrela');
                case 3:
                    return this.$t('sectionPesquisaSatisfacao.nps');
                case 4:
                    return this.$t('sectionPesquisaSatisfacao.simNao');
                default:
                    return this.$t('sectionPesquisaSatisfacao.comentario');
            }
        },
        ObterGrid() {
            this.loading = true;
            this.$http({
                url: "pesquisa-satisfacao/relatorio",
                data: this.filtro,
                method: "POST"
            })
                .then((response) => {
                    console.log("resposta ", response.data)
                    this.resultados = response.data;
                    this.loading = false;
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        DownloadCsv(){
        var vm = this

        this.$http({url: "pesquisa-satisfacao/relatorio-csv",data: this.filtro, method: 'POST', responseType: 'blob', })
            .then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download','relatorio.csv')
            document.body.appendChild(link)
            link.click()


        })
        .catch(err => {
            alert(err.message)
        })
        }
    }
};
</script>
  